import apiService from "../../api/api.service";
import { SettingsRawResponse } from "./settings.types";

export const fetchSettings = () => {
  return apiService.get<SettingsRawResponse>("/general/settings");
};
